import Modal from "../../molecules/Modal";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const Claims = ({ ...props }) => {
  const [claimsData, setClaimsData] = useState([]);
  const [claimsLoading, setClaimsLoading] = useState(true);
  const [openViewer,setOpenViewer] = useState(false);
  const [openPrepareViewer,setOpenPrepareViewer] = useState(false);

  // Important Notice bullet items array
  const importantNoticeItems = [
    "Advice of Loss should be made within thirty (30) days from the Date of the incident, otherwise no claim shall be entertained.",
    "Submission of all <a class='text-blue-500 text-xs font-bold underline'>relevant documents</a> must be within thirty (30) days from expiry of the Travel Policy. Failure to submit necessary documents within the given period shall be deemed abandonment of the claim.",
    "All documents to be submitted shall be in English.",
    "The Company reserves the right to require additional documents as it may consider necessary to support the claim.",
  ];

  // Prepare list for compulsory documents
  const prepareList = [
    "Accomplished <a class='text-blue-500 text-xs font-bold underline'>Claims Form</a>",
    "Incident Report / Affidavit of Loss",
    "Original Official Receipts of all payments made",
    "Copy of Flight Itinerary & Boarding Passes",
    "Copy of Passport (pages with details and dates stamped for entries and departures)",
    "Birth Certificate (if claimant is a minor)",
  ];

  useEffect(() => {
    setClaimsLoading(false);
    setClaimsData(props.claims);
  }, [props.claims]);

  return (
    <>
      <div className="max-w-md p-5 max-w-full bg-white shadow rounded-lg mb-5">
        <div>
          <h2 className="text-gray-800 text-sm font-bold leading-snug mb-3 text-center">
            How do I make a claim?
          </h2>

          {claimsLoading || (
            <>
              <p className="text-gray-600 text-xs leading-snug ml-3">
                For all claims and assistance:
              </p>
              {claimsData?.map((data, index) => (
                <div className="" key={index}>
                  <div className="grid grid-cols-6 gap-4 mt-5">
                    <div
                      className={`${
                        index === 0
                          ? "covered-image-white self-center"
                          : "covered-image covered-image-white self-center"
                      }`}
                    >
                      <img
                        src={data.imageUrl}
                        alt="claims"
                        className="covered-icon"
                      />
                    </div>
                    <div key={index} className="self-center col-span-5">
                      <h5 className="ml-3 font-semibold mb-1 text-sm leading-tight">
                        {data.title}
                      </h5>

                      <p
                        className="text-gray-600 text-xs leading-snug ml-3"
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.description) }}
                      ></p>
                    </div>
                  </div>
                  <div className="grid grid-cols-6 gap-4">
                    <div className="self-center"></div>
                    {/* BULLETED ITEMS */}
                    <div className="self-center col-span-5">
                      {data.item !== undefined &&
                        data.item !== null &&
                        data.item.length > 0 && (
                          <ul className="ml-3 font-semibold mb-1 text-sm leading-tight">
                            {data.item?.map((item, itemIndex) => (
                              <li key={itemIndex} className="list-disc">
                                {item}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                </div>
              ))}
              <div className="self-center col-span-5 mt-3">
                <h5 className=" font-semibold mb-1 text-sm leading-tight">
                  Important Notice:
                </h5>
                <ul className="ml-5 font-normal mb-1 text-xs leading-tight">
                  {importantNoticeItems.map((item, index) => (
                    <li
                      className={"ml-5 list-disc"}
                      key={index}
                    >
                      {index === 1 ? (
                        <a 
                          dangerouslySetInnerHTML={{ __html: sanitizeHtml(item) }}
                          onClick={() => setOpenViewer(true)}
                          href={"/files/travel/relevant_documents.pdf"} download={"/files/travel/relevant_documents.pdf"}
                          className="cursor-pointer"
                        />
                      ) : (
                        <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(item) }} />
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="self-center col-span-5 mt-3 ml-3">
                <p className=" mb-1  font-normal mb-1 text-xs leading-tight">
                  Prepare the following COMPULSORY DOCUMENTS for all types of
                  claims:
                </p>
                <ul className="ml-5 mt-3 font-normal mb-1 text-xs leading-tight">
                  {prepareList.map((item, index) => (
                    <li
                      className={"ml-5 list-disc"}
                      key={index}
                    >
                      {index === 0 ? (
                        <a 
                          dangerouslySetInnerHTML={{ __html: sanitizeHtml(item) }}
                          href={"/files/travel/claims_form.pdf"} download={"/files/travel/claims_form.pdf"}
                          className="cursor-pointer"
                        />
                      ) : (
                        <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(item) }} />
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
      
      {/* <Modal open={openViewer} setOpen={setOpenViewer} title="Relevant Documents">
        <div className="max-h-96 overflow-y-auto px-4 py-2">
          <div className="space-y-4 text-sm">
            <section>
              <object
                data={"/files/travel/relevant_documents.pdf"}
                type="application/pdf"
                width="100%"
                height="800px"
              ></object>{" "}
          </section>
          </div>
        </div>
      </Modal>
      <Modal open={openPrepareViewer} setOpen={setOpenPrepareViewer} title="Claims Form" >
        <div className="max-h-96 overflow-y-auto px-4 py-2">
          <div className="space-y-4 text-sm">
            <section>
              <object
                data={"/files/travel/claims_form.pdf"}
                type="application/pdf"
                width="100%"
                height="800px"
              ></object>{" "}
            </section>
          </div>
        </div>
      </Modal> */}
    </>
  );
};

export default Claims;
